import EventEmitter from '../Bases/events/EventEmitter.js';

const events = new EventEmitter();

export default events;
